// frontend/src/utils/descricaoSuggestions.jsx
import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

/**
 * Monta o rótulo exibido no dropdown de sugestões de descrição.
 * Mostra a descrição e, ao lado, a categoria vinculada — assim o usuário
 * consegue diferenciar descrições parecidas (ex.: "Litoral" x "Litoral Supermercado")
 * e escolher a que já está na categoria correta.
 *
 * Quando `onDelete` é informado, exibe um botão para remover a sugestão
 * (o clique não seleciona a opção).
 */
export const renderDescricaoSuggestionLabel = (sugestao, onDelete) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {sugestao.descricao}
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
            {sugestao.categoria_nome ? (
                <Tag style={{ marginInlineEnd: 0 }}>{sugestao.categoria_nome}</Tag>
            ) : null}
            {onDelete ? (
                <Tooltip title="Remover das sugestões">
                    <CloseCircleFilled
                        aria-label={`Remover a sugestão ${sugestao.descricao}`}
                        style={{ color: 'var(--color-text-secondary, #8c8c8c)', fontSize: 14 }}
                        onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onDelete(sugestao);
                        }}
                    />
                </Tooltip>
            ) : null}
        </span>
    </div>
);

/**
 * Converte a resposta da API de sugestões em `options` para o <AutoComplete>.
 * @param {Array} results
 * @param {{ onDelete?: (sugestao: object) => void }} [opts]
 */
export const mapDescricaoSuggestions = (results = [], { onDelete } = {}) =>
    results.map((s) => ({
        value: s.descricao,
        label: renderDescricaoSuggestionLabel(s, onDelete),
        categoria_id: s.categoria_id,
        id: s.id,
    }));
